import type { FC } from 'react'

import type { getFeaturedArticles, latestArticlesByCategory } from '@/graphql/HealthAcademyCategories'
import type { AcademyHomepageRecord } from '@/graphql/HealthAcademyHomepage'

import { Footer } from '@/components/elements/footer/Footer'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

import { SubNavigation } from '@/elements/global/SubNavigation'
import { Header } from '@/elements/header/Header'

import type { AcademyCategories } from './AcademyContentPage'
import { ArticlesByCategory } from './Article/ArticlesByCategory'
import { LatestFeaturedArticles } from './Article/LatestFeaturedArticles'
import { HomepageContent } from './HomePage/HomepageContent'

// Derived from the GraphQL helpers `pages/learn/index.tsx` fetches these with.
type AcademyHomePageProps = {
  homepage: NonNullable<AcademyHomepageRecord>
  categories: AcademyCategories
  articlesByCategory: Array<Awaited<ReturnType<typeof latestArticlesByCategory>>>
  featuredArticles: Awaited<ReturnType<typeof getFeaturedArticles>>
}

export const AcademyHomePage: FC<AcademyHomePageProps> = ({
  homepage,
  categories,
  articlesByCategory,
  featuredArticles,
}) => {
  return (
    <>
      <SEOMetaTags metaData={homepage.metaData ?? undefined} />
      <Header />
      <SubNavigation title="Learn" categories={categories} />
      <main id="main-content">
        <HomepageContent page={homepage} />
        <LatestFeaturedArticles featuredArticles={featuredArticles} />
        {categories.map((category, categoryIndex) => {
          const articles = articlesByCategory[categoryIndex]
          return (
            <ArticlesByCategory
              key={category.id}
              categoryID={category.id}
              categoryName={category.categoryName}
              categorySlug={category.categorySlug}
              articles={articles}
              showHeader={true}
            />
          )
        })}
      </main>
      <Footer showPreFooter />
    </>
  )
}
